/**
 * W5 — one read of the shop's bay names, made only while a multi-bay column is shown (enabled=false costs nothing).
 * Display only; replaces nothing (TicketCard keeps its own bay read, unchanged).
 */
import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

const cache = new Map<string, Map<string, string>>();

export function useShopBayNames(shopId: string | null | undefined, enabled: boolean): Map<string, string> | null {
  const [names, setNames] = useState<Map<string, string> | null>(shopId ? cache.get(shopId) ?? null : null);
  useEffect(() => {
    if (!enabled || !shopId) return;
    if (cache.has(shopId)) { setNames(cache.get(shopId)!); return; }
    let cancelled = false;
    void (async () => {
      const { data, error } = await supabase.from('shop_bays').select('id, name').eq('shop_id', shopId);
      if (cancelled || error) return;
      const m = new Map<string, string>((data ?? []).map((b: { id: string; name: string }) => [b.id, b.name]));
      cache.set(shopId, m);
      setNames(m);
    })();
    return () => { cancelled = true; };
  }, [shopId, enabled]);
  return names;
}
